import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import type { IRenderContextMenuItemArgs } from '@/plugins/context-menu/type';
import { LayerHotkeyType } from '../../type';

export const layerSortItem = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs, identity: string) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);
    const layer = pickLayer || activeLayer;
    const disabled = !layer;

    if (disabled || !activeLayer) return null;
    const isArranging = framework.service.agentLayout.checkArranging(activeLayer);
    const layerSortData = framework.service.frame.getLayerSortData(activeLayer.id);

    const sortTopType = LayerHotkeyType.SORT_TOP;
    const sortBottomType = LayerHotkeyType.SORT_BOTTOM;
    const sortUpType = LayerHotkeyType.SORT_UP;
    const sortDownType = LayerHotkeyType.SORT_DOWN;

    const item = {
        disabled: disabled || isArranging,
        name: $t((v) => v.Text_LayerSort),
        type: 'sort',
        childMenus: [
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.sortTop),
                disabled: layerSortData.operate.disableUp,
                type: sortTopType,
                desc: framework.service.hotkey.getDesc(sortTopType),
                onClick: () => {
                    framework.service.hotkey.__emit(sortTopType, { from: 'context-menu' });
                },
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.sortBottom),
                disabled: layerSortData.operate.disableDown,
                type: sortBottomType,
                desc: framework.service.hotkey.getDesc(sortBottomType),
                onClick: () => {
                    framework.service.hotkey.__emit(sortBottomType, { from: 'context-menu' });
                },
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.sortUp),
                disabled: layerSortData.operate.disableUp,
                type: sortUpType,
                desc: framework.service.hotkey.getDesc(sortUpType),
                onClick: () => {
                    framework.service.hotkey.__emit(sortUpType, { from: 'context-menu' });
                },
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.sortDown),
                disabled: layerSortData.operate.disableDown,
                type: sortDownType,
                desc: framework.service.hotkey.getDesc(sortDownType),
                onClick: () => {
                    framework.service.hotkey.__emit(sortDownType, { from: 'context-menu' });
                },
            },
        ],
    };

    return item;
};
